import PropTypes from 'prop-types';
import { EmailIcon, WhatsappIcon, FacebookIcon } from '@spotahome/ui-library';
import { useShare } from '@spotahome/ui-library/src/tenant/context/ShareContext';

import { capitalizeFirstLetter } from '../../../utils/stringUtils';

import RoundButtonWithIconWrapper from './RoundButtonWithIconWrapper/RoundButtonWithIconWrapper';

const SOCIAL_CONFIG = {
  email: {
    bcColor: '#0a0d77',
    event: 'Email',
    icon: EmailIcon,
    getUrl: encodedText => `mailto:?body=${encodedText}`
  },
  whatsapp: {
    bcColor: '#25d366',
    event: 'WhatsApp',
    icon: WhatsappIcon,
    getUrl: encodedText => `https://api.whatsapp.com/send?text=${encodedText}`
  },
  facebook: {
    bcColor: '#4267b2',
    event: 'Facebook',
    icon: FacebookIcon,
    getUrl: encodedText =>
      `https://www.facebook.com/sharer/sharer.php?u=${encodedText}`
  }
};

const addSearchStringToCurrentUrl = searchString => {
  const { href, search } = window.location;
  return `${href}${search ? '&' : '?'}${searchString}`;
};

const getUTMParams = social =>
  `utm_source=spotahome&utm_medium=sharebuttonlisting&utm_campaign=${social}`;

const ShareOnSocial = ({ social }) => {
  const socialConfig = SOCIAL_CONFIG[social];
  const SocialIcon = socialConfig.icon;
  const utmParams = getUTMParams(social);
  const urlToShare = addSearchStringToCurrentUrl(utmParams);
  const encodedText = encodeURIComponent(urlToShare);
  const { incrementShare } = useShare();

  const handleShareClick = e => {
    e.stopPropagation();
    incrementShare(socialConfig.event);
  };

  const content = (
    <RoundButtonWithIconWrapper
      type={social}
      text={capitalizeFirstLetter(social)}
      backgroundColor={socialConfig.bcColor}
      onClick={handleShareClick}
    >
      <a
        href={socialConfig.getUrl(encodedText)}
        target="_blank"
        rel="noopener noreferrer"
        data-cy={`booknow_card_share_${social}`}
      >
        <SocialIcon />
      </a>
    </RoundButtonWithIconWrapper>
  );

  return social === 'facebook' ? (
    <div id="fb-root">
      <script
        async
        defer
        crossOrigin="anonymous"
        src="https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v3.3"
      />
      {content}
    </div>
  ) : (
    content
  );
};

ShareOnSocial.propTypes = {
  social: PropTypes.oneOf(Object.keys(SOCIAL_CONFIG)).isRequired
};

export default ShareOnSocial;
